module.exports = __webpack_public_path__ + "img/token.21693c59.svg";